import script from "./EditTerminalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTerminalComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditTerminalComponent.vue?vue&type=style&index=0&id=4fbc23e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fbc23e8"]])

export default __exports__